const DEFAULT_CLASSNAMES = {
  td: "w-full",
  input: "w-full font-ubuntuRegular shadow h-[36px] text-center p-1 rounded",
  span: "font-ubuntuRegular absolute inset-y-0 left-0 flex items-center pl-2",
  currencySymbol: "text-gray-500",
};

const TYPE_MAP = {
  number: {
    format: (value) => value,
  },
  currency: {
    format: (value) => value,
  },
};

const TableNumberInput = ({
  classNames = DEFAULT_CLASSNAMES,
  value = "0.00",
  type = "number",
  ...otherProps
}) => {
  return (
    <td className={classNames.td}>
      <div className="relative">
        {type === "currency" && (
          <span className={classNames.span}>
            <span className={classNames.currencySymbol}>$</span>
          </span>
        )}
        <input
          value={TYPE_MAP[type].format(value) || ""}
          type="number"
          {...otherProps}
          className={`pl-6 ${classNames.input}`}
        />
      </div>
    </td>
  );
};

export default TableNumberInput;
